import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AuthFacade } from '@mitsubishi/core';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'apm-input-type',
  templateUrl: './input-type.component.html',
  styleUrls: ['./input-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InputTypeComponent extends FieldType<FieldTypeConfig> {
  #authFacade = inject(AuthFacade);

  canDebug = this.#authFacade.canDebug;

  ignoredKeyCodes = ['KeyE'];

  onKeyDown(e: KeyboardEvent) {
    if (this.ignoredKeyCodes.includes(e.code)) {
      e.preventDefault();
    }
  }
}
